export enum SessionState {
  /**
   * Initial state until we initialize the session state based on local storage
   */
  Unknown = 'unknown',
  /**
   * ACTIVE state is when the user is actively interacting with the app by clicking, typing, etc.
   */
  Active = 'active',
  /**
   * STALE state is when the user has stopped interacting with the app for a period of time.
   * They will see the WarningCard and have the option to extend their session.
   */
  Stale = 'stale',
  /**
   * LOCKED state is when the user has not interact with the app for over 10 minutes.
   */
  Locked = 'locked',
}

/**
 * Request state for loginRedirect call
 */
export interface ILoginRequestState {
  /**
   * Path to redirect to after login
   */
  originUrl?: string;

  /**
   * Count of login attempts
   */
  loginCount: number;
  /**
   * Whether login redirect was called from a custom popup or not
   */
  isCustomPopup?: boolean;
}

export interface IAuthState {
  /**
   * The loginRedirect request state
   */
  requestState: ILoginRequestState;

  /**
   * Whether login redirect was successful or not
   */
  loginRedirectSuccess?: boolean;

  /**
   * Whether we should use default scope for MSAL login
   */
  useDefaultScope?: boolean;

  /**
   * The current session state
   */
  sessionState: SessionState;
}
